import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";

import type { getSpecificationsComponent } from "@/lib/api/formatting/rorosTweed/productPage";

import ProductAccordion from "../ProductAccordion";
import WishlistToggle from "../WishlistToggle";
import styles from "./specifications.module.scss";

type Props = {
  id: string;
  specification: Partial<ReturnType<typeof getSpecificationsComponent>>["data"];
};

const Specification = ({ id, specification }: Props) => {
  const t = useTranslations();
  const { locale } = useRouter();
  const category = specification?.category;
  const material = specification?.material;
  const size = specification?.size;
  const weight = specification?.weight;
  const origin = specification?.origin?.find(
    (o) => o.locale === locale || o.locale === "en"
  )?.country;

  return (
    <ProductAccordion
      title={t("specification")}
      titleExtraComponent={id && <WishlistToggle id={id} />}
    >
      <div className={styles.table}>
        {category && (
          <>
            <p className={styles.title}>{t("category")}</p>
            <Link href={category.categoryUri} className={styles.text}>
              {category.categoryTitle[0]}
            </Link>
          </>
        )}
        {material && (
          <>
            <p className={styles.title}>{t("material")}</p>
            <p className={styles.text}>{material}</p>
          </>
        )}
        {origin && (
          <>
            <p className={styles.title}>{t("madeIn")}</p>
            <p className={styles.text}>{origin}</p>
          </>
        )}
        {size && (
          <>
            <p className={styles.title}>{t("size")}</p>
            <p className={styles.text}>{size}</p>
          </>
        )}
        {weight && (
          <>
            <p className={styles.title}>{t("weight")}</p>
            <p className={styles.text}>{weight}</p>
          </>
        )}
      </div>
    </ProductAccordion>
  );
};

export default Specification;
